import { useI18n } from "@/i18n";
import { unitOfferCopy } from "@/lib/unit-offer";

interface PriceFromProps {
  /** Owner-approved unit price, matching the page's schema offers.price */
  price: number;
  currency?: string;
  note?: string;
  /** Use "light" on dark/photographic hero backgrounds */
  tone?: "default" | "light";
  className?: string;
}

/**
 * Visible localized unit offer for product pages.
 * The value MUST match the offers.price in the page's Product JSON-LD
 * to avoid structured-data / visible-content price mismatches.
 */
export const PriceFrom = ({
  note,
  tone = "default",
  className = "",
}: PriceFromProps) => {
  const { language } = useI18n();
  const copy = unitOfferCopy[language];
  return (
  <div className={`mb-8 flex flex-wrap items-baseline gap-x-3 gap-y-1 ${className}`}>
    <span className={`font-inter text-sm uppercase tracking-wider ${tone === "light" ? "text-white/70" : "text-muted-foreground"}`}>
      {copy.label}
    </span>
    <span className={`font-playfair text-3xl font-semibold ${tone === "light" ? "text-white" : "text-primary"}`}>
      {copy.amount}
    </span>
    <span className={`font-inter text-sm ${tone === "light" ? "text-white/80" : "text-muted-foreground"}`}>{copy.unit}{note ? `. ${note}` : ""}</span>
  </div>
  );
};

export default PriceFrom;
